import * as React from 'react';

const StylingIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={19}>
    <path
      fill={fillColor}
      d="m15.918 5.354-.709-1.562-1.562-.709 1.562-.708.709-1.562.708 1.562 1.562.708-1.562.709-.709 1.562Zm-10.042 0-.708-1.562-1.563-.709 1.563-.708.708-1.562.708 1.562 1.563.708-1.563.709-.708 1.562Zm10.041 10.042-.708-1.563-1.562-.708 1.562-.708.709-1.563.708 1.563 1.562.708-1.562.708-.709 1.563Zm-13.02 2.687-1.98-1.979a.812.812 0 0 1-.25-.531c-.013-.201.07-.392.25-.573l9.376-9.375a.823.823 0 0 1 .604-.25c.236 0 .437.083.604.25L13.376 7.5c.167.167.25.368.25.604a.823.823 0 0 1-.25.604L4 18.083c-.167.167-.35.25-.552.25-.202 0-.386-.083-.552-.25Zm.479-1.187 6.52-6.521-1.291-1.292-6.52 6.521 1.29 1.292Z"
    />
  </svg>
);

export default StylingIcon;
